import './pdfPreviewComponent.scss';
import React, {useEffect, useState} from 'react';

interface PdfPreviewComponentProps {
    attachmentFile?: any;
    attachmentUrl?: any;
    arrayBuffer?: { type: string; data: number[] }; // Updated type for Node.js Buffer-like data
    width?: string;
    height?: string;
    isFile?: boolean;
}

const PdfPreviewComponent = (props: PdfPreviewComponentProps) => {
    const {attachmentFile, attachmentUrl, arrayBuffer, isFile} = props; // Handle buffer-like input
    let {width, height} = props
    const [attachmentPreviewUrl, setAttachmentPreviewUrl] = useState<any>();

    if (!width) width = '850'
    if (!height) height = '500'

    useEffect(() => {
        if (isFile) {
            if (!attachmentFile) {
                setAttachmentPreviewUrl(undefined)
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                setAttachmentPreviewUrl(reader.result);
            };
            if (attachmentFile) {
                reader.readAsDataURL(attachmentFile);
                setAttachmentPreviewUrl(reader.result);
            } else {
                setAttachmentPreviewUrl("");
            }
        } else if (attachmentUrl) {
            setAttachmentPreviewUrl(attachmentUrl);
        } else if (arrayBuffer && arrayBuffer.type === 'Buffer') {
            // Convert Node.js Buffer-like object to an ArrayBuffer
            const typedArray = new Uint8Array(arrayBuffer.data);
            const blob = new Blob([typedArray], {type: 'application/pdf'});
            const url = URL.createObjectURL(blob);
            setAttachmentPreviewUrl(url);
        }
    }, [attachmentFile, attachmentUrl, arrayBuffer, isFile]);

    return (
        <div>
            <object
                data={attachmentPreviewUrl}
                width={width} height={height}
                aria-label={"attachment"}
                type="application/pdf"/>
        </div>
    )
}

export default PdfPreviewComponent;
